import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_13} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE_LIGHT, GRAY_DARK} from 'ui-library/Colors';
import AddIcon from 'ui-library/icons/AddIcon';

interface AddItemButtonProps {
  disabled?: boolean;
  onClick: () => void;
  label: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function AddItemButton({
  disabled,
  onClick,
  label,
  dataTestAttrs,
}: AddItemButtonProps): JSX.Element {
  return (
    <div
      className={css(styles.addStepSection, disabled && styles.disabledAddStepSection)}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      {...getTestProps(dataTestAttrs)}
    >
      <AddIcon
        // AddIcon by default adds `u-small-spacing-left`, but we don't want that spacing here
        className=""
        disabled={disabled}
      />
      <span className="u-mini-spacing-left">{label}</span>
    </div>
  );
}

const styles = StyleSheet.create({
  addStepSection: {
    ...FONT_PROXIMA_13,
    color: BLUE_LIGHT,
    cursor: 'pointer',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  disabledAddStepSection: {
    color: GRAY_DARK,
    cursor: 'not-allowed',
  },
});
